import { TextMultiValuedListItem } from '../../../TextMultiValuedList'

import * as styles from './ListItem.module.css'

function ListItem({ display_name: name, ...restProps }) {
  return (
    <TextMultiValuedListItem
      {...restProps}
      isSecondary
      className={styles.listItem}
    >
      {name}
    </TextMultiValuedListItem>
  )
}

export default ListItem
